<template>
  <FlatActionButton
    :action="handleButtonClick"
    :buttonClass="['btnDefault', 'btnCTA']"
  >
    {{ buttonText }}
  </FlatActionButton>
</template>

<script>

import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'BindToUserButton',

  components: {
    FlatActionButton,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    handleClick: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    handleButtonClick(e) {
      this.handleClick(e, this.item);
    },
  },
};
</script>
